import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
    fields: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(3),
        maxWidth: 720,
    },
    salesforceFieldRow: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: theme.spacing(1),
    },
}));
